import React from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, useRouteMatch, useParams } from 'react-router-dom';
import { Code } from '../codes/_models';
import { hasViewPermissions } from '../profile/_utils';
import SecondaryNav from '../_routing/layouts/authorized/menu/SecondaryNav';
import { ForbiddenPage } from '../_shared';
import { codesSelectors, profileSelectors, storesSelectors } from '../_store/selectors';
import PricesOverview from './overview/PricesOverview';

const Prices: React.FC = () => {
  const { url } = useRouteMatch();
  const { storeId } = useParams<{ storeId: string }>();
  const currentStore = useSelector(storesSelectors.currentStore);
  const profile = useSelector(profileSelectors.profile);
  const codes = useSelector(codesSelectors.codes);

  const hasViewPermission = hasViewPermissions(codes, Code.Price, currentStore?.id, profile.permissions);

  return (
    <>
      <SecondaryNav />
      <Switch>
        <Route
          exact
          path={url}
          render={props => (hasViewPermission ? <PricesOverview {...props} storeId={storeId} /> : <ForbiddenPage />)}
        />
      </Switch>
    </>
  );
};

export default Prices;
